import { useCallback } from "react";
import useFetch from "../../hooks/useFetch";
import { useShowMessage } from "../Common/showMessage";

function useUpdatePlateItems() {
  const [fetchWrapper] = useFetch();
  const showMessage = useShowMessage();

  const updatePlateItems = useCallback(
    (plates, setPlates, setSelectedItemKey) => {
      fetchWrapper({
        endpoint_url: "item_details/updatePlateItems",
        params: {
          plates: plates,
        },
        onSuccess: (fetch_output) => {
          if (!("error" in fetch_output)) {
            let data = fetch_output["data"];
            setPlates(data);
            setSelectedItemKey(null);
          } else {
            showMessage({ message: fetch_output.error });
          }
        },
        onFetchError: () =>
          showMessage({ apiType: "fetch", message: "Update Plate Items" }),
        onResponseError: () =>
          showMessage({ apiType: "response", message: "Update Plate Items" }),
      });
    },
    [fetchWrapper]
  );

  return { updatePlateItems };
}

export default useUpdatePlateItems;
